import { withInstall } from '@ll-plus/utils'

import MarkdownEditor from './src/markdown-editor.vue'

import MarkdownPreviewer from './src/components/markdown-previewer.vue'

export const LlMarkdownEditor = withInstall(MarkdownEditor)

export const LlMarkdownPreviewer = withInstall(MarkdownPreviewer)

export * from './src/config'

declare module 'vue' {
  export interface GlobalComponents {
    LlMarkdownEditor: typeof MarkdownEditor
    LlMarkdownPreviewer: typeof MarkdownPreviewer
  }
}
